import {IntermediatePart} from "../../intermediatePart";
import {getFeatureIsLocked} from "../../../../../misc/helpers";
// import {ShowerComboTubType} from "../../constants";
import {ShowerTubCombo} from "../../parts/showerTubCombo";
import {ShowerAccessories} from "../../parts/showerAccessories";
import {removeLookPointFor} from "../../../lookNavigation/lookFunctions2";
import {getCurrentRoomType} from "../../../../appLayout";
import {LayoutType, LOOK_ROOM_TYPES, METADATA, ShowerComboTubType} from "../../constants";
import {IS_QKB_UI} from "../../../../../config";

export default class ShowerDoor extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'shower_door';
    this.partName = 'Shower Door';
    this.translateId = "visualizer.bathroom.shower.shower_door";
    this.visible = true;
    this.isStoneFeature = false;
    this.canBeDisabled = true;
    this.layerPriority = 5;

    /* only shower door properties */
    if (isChild) {
      this.previouslySelectedFeatures = {};
      this.oneLayerPosition = true;
      Object.keys(LayoutType).forEach(layoutName => {
        this.previouslySelectedFeatures[layoutName] = {};
      })
    }
    this.currentShowerBodyId = ""; // for example "custom-a-60in-30x8"
  }

  load(dbFeature) {
    if (!dbFeature.metaData["Side"]) {
      dbFeature.metaData["Side"] = [METADATA.LeftSide];
    }
    dbFeature.metaData["layerPosition"] = dbFeature.metaData["Side"] ? dbFeature.metaData["Side"][0] : "";
    dbFeature.lixilProductSubCategory = "Shower Doors"; // because some of them are missing this subcategory!
    return super.load(dbFeature);
  }

  navigationSubItems(...props) {
    if (IS_QKB_UI) {
      return this.navigationSubItemsWithSides(...props);
    }
    return super.navigationSubItems(...props);
  }

  disabledClick() {
    const showerParent = this.getParent();
    const showerDoorHandle = showerParent.showerDoorHandle;
    if (showerDoorHandle && showerDoorHandle) {
      showerDoorHandle.disabled = this.disabled || !showerDoorHandle.canBeEnabled(); // true or check if it can be enabled;
    }
    const accParent = showerParent.layout.parts[ShowerAccessories.id]
    if (!this.disabled && accParent && accParent.showerRod && !accParent.showerRod.disabled
      && accParent.showerRod) {
      accParent.showerRod.disabled = true
    }
  }

  handleClick() {
    super.handleClick();
    if (!this.notAvailableInVisualizer && !getFeatureIsLocked(this)) {
      // this.getParent().getParent().setShowerTubCombo();
      // let doorWithLiner = false;
      // if(this.metaData && this.metaData.length) {
      //   const activeDoorMetadata = this.metaData.find(metaDataObject => metaDataObject.isFor);
      //   const showerPanValues = activeDoorMetadata.conditions.find(condition => condition.name === "BathtubLiner");
      //   if (showerPanValues) {
      //     doorWithLiner = true;
      //   }
      // }
      // this.getParent().getParent().setLinerActive(doorWithLiner);
      const shower = this.getParent().getParent();
      const showerPanCondition = this.metaData["ShowerPan"];
      if (!shower.showerTubComboIsActive()) {
        shower.showerFloorIsActive = showerPanCondition && showerPanCondition.includes("Threshold");
      }
      const accParent = shower.layout.parts[ShowerAccessories.id]
      if (accParent && accParent.showerRod && !accParent.showerRod.disabled) {
        accParent.showerRod.disabled = true
      }
      if(!this.matchesMetaForArrayOfConditions(this.getParent().getArrayOfConditions())) {
        const showerSizeValues = this.metaData["ShowerSize"];
        const showerBodyParent = this.getParent().getParent().showerBody;
        if (showerSizeValues) {
          const showerBodyThatFits = showerBodyParent.features.filter(showerBodyFeature => {
            const showerSizeValues2 = showerBodyFeature.metaData["ShowerSize"];
            return showerSizeValues.some(condValue => {
              return showerSizeValues2.some(condValue2 => condValue === condValue2);
            });
          });
          if (showerBodyThatFits.length && showerBodyThatFits.every(shBody => shBody.partName !== showerBodyParent.activeFeature.partName)) {
            let showerBodyToSet = showerBodyThatFits.find(shBody => {
              return shBody.showerDimensions === showerBodyParent.activeFeature.showerDimensions
            }) || showerBodyThatFits[0];
            showerBodyParent.showerBodySelectedByUser = true;
            showerBodyParent.activeFeature = showerBodyToSet;
          }
        }
      }
      this.featureClicked();
    }
  }

  // setLayers(layout) {
  //   const showerParent = this.getParent();
  //   // const comboParent = showerParent.layout.parts[ShowerTubCombo.id];
  //   // if (showerParent.showerTubComboIsActive() && comboParent.bottomTub === ShowerComboTubType.walk_in_tub) {
  //   if (showerParent.showerTubComboIsActive()) {
  //     super.hideLayers();
  //     return;
  //   }
  //   return super.setLayers(layout);
  // }

  getArrayOfConditions() {
    const showerParent = this.getParent();
    const comboParent = showerParent.layout.parts[ShowerTubCombo.id];
    let conditions = super.getArrayOfConditions(); //roomLayout
    const showerSize = showerParent.showerSize();
    if (showerSize) {
      conditions.push({
        propName: "ShowerSize",
        propValue: showerSize
      })
    }
    // if (showerParent.showerTubComboIsActive() && comboParent.bottomTub === ShowerComboTubType.replacement_tub
    //   && comboParent.replacementTub && comboParent.replacementTub.activeFeature && comboParent.replacementTub.activeFeature.metaData["ShowerPanHeight"]) {
    //   conditions.push({
    //     propName: "ShowerPanHeight",
    //     propValue: comboParent.replacementTub.activeFeature.metaData["ShowerPanHeight"]
    //   })
    if (showerParent.showerTubComboIsActive()) {
      if (comboParent && comboParent.bottomTub === ShowerComboTubType.replacement_tub) {
        if (comboParent.replacementTub && comboParent.replacementTub.activeFeature
          && comboParent.replacementTub.activeFeature.metaData
          && comboParent.replacementTub.activeFeature.metaData["ShowerPanHeight"]) {
          conditions.push({
            propName: "ShowerPanHeight",
            propValue: comboParent.replacementTub.activeFeature.metaData["ShowerPanHeight"]
          })
        }
      } else {
        conditions.push({
          propName: "NOT_EXISTING_METADATA",
          propValue: "whatever"
        })
      }
    } else if (showerParent && showerParent.showerPanCombo
      && showerParent.showerPanCombo.activeFeature && showerParent.showerPanCombo.activeFeature.metaData["ShowerPanHeight"]) {
      conditions.push({
        propName: "ShowerPanHeight",
        propValue: showerParent.showerPanCombo.activeFeature.metaData["ShowerPanHeight"]
      })
    }
    return conditions
  }

  canDisplayDemoPoint(parentObject) {
    if (getCurrentRoomType() === LOOK_ROOM_TYPES.as) {
      return removeLookPointFor(parentObject, 3, "1") && removeLookPointFor(parentObject, 6, "1")
    }
    return true
  }
}
